<!-- <logzy-table-loader *ngIf="loading"></logzy-table-loader>a -->
<div class="vstack vstacker"  [class.gap-2]="requestVisibilityExpand">
    <div class="HeaderSet">
        <span class="editHead editHeadCursor" [ngClass]="requestVisibilityExpand? 'editHeadRad':'editHeadRod' " (click)="requestVisibilityExpand = !requestVisibilityExpand">
            Request Visibility
            <i class="flaticon-down-chevron" [ngClass]="requestVisibilityExpand? 'more':'' "></i>
        </span>
    </div>
    <div class="additionalDetails" [class.viewExpand]="requestVisibilityExpand">
            <div *ngIf="!isCustomer && !loading && reqAllocationList.data.length!=0" class="setTable">
                <mat-table [dataSource]="reqAllocationList">
                    <ng-container matColumnDef="allocated_from">
                        <mat-header-cell *matHeaderCellDef> Shared By </mat-header-cell>
                        <mat-cell *matCellDef="let data">
                            <div class="details" fxLayout="column">
                                <ng-container *ngIf="data.allocated_from==null">
                                    System Assigned
                                </ng-container>
                                <ng-container *ngIf="data.allocated_from!=null">
                                    <span class="fw-medium">{{data.allocated_from?.first_name}}
                                        {{data.allocated_from?.last_name}}</span>
                                    <small>{{data.allocated_from?.email}}</small>
                                </ng-container>
                            </div>
                        </mat-cell>
                    </ng-container>
            
                    <ng-container matColumnDef="allocated_to">
                        <mat-header-cell *matHeaderCellDef> Shared To </mat-header-cell>
                        <mat-cell *matCellDef="let data">
                            <div class="details" fxLayout="column">
                                <ng-container *ngIf="data.allocated_to!=null">
                                    <span class="fw-medium">{{data.allocated_to?.first_name}}
                                        {{data.allocated_to?.last_name}}</span>
                                    <small>{{data.allocated_to?.email}}</small>
                                </ng-container>
                                <ng-container *ngIf="data.allocated_to==null">-</ng-container>
                            </div>
                        </mat-cell>
                    </ng-container>
            
                    <ng-container matColumnDef="updated_at">
                        <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
                        <mat-cell *matCellDef="let data">{{data.updated_at | date:'dd MMM, yyyy'}}</mat-cell>
                    </ng-container>
            
                    <ng-container matColumnDef="transfer_reason">
                        <mat-header-cell *matHeaderCellDef> Reason </mat-header-cell>
                        <mat-cell *matCellDef="let data">
                            <ng-container *ngIf="data.transfer_reason==null">-</ng-container>
                            <ng-container *ngIf="data.transfer_reason!=null">
                                {{data.transfer_reason?.name}}
                            </ng-container>
                        </mat-cell>
                    </ng-container>
            
                    <ng-container matColumnDef="remarks">
                        <mat-header-cell *matHeaderCellDef> Remarks </mat-header-cell>
                        <mat-cell *matCellDef="let data">
                            <ng-container *ngIf="data.remarks==null">-</ng-container>
                            <ng-container *ngIf="data.remarks!=null">
                                {{data.remarks}}
                            </ng-container>
                        </mat-cell>
                    </ng-container>
            
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
                <div class="loadingData" [class.d-none]="!update">
                    <logzy-gear-loader></logzy-gear-loader>
                </div>
                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users" [pageSize]="10"
                    [length]="pageLength" (page)="pageChanged($event)"></mat-paginator>
            </div>
    </div>
</div>

<ng-container *ngIf="!isCustomer && feedbackResponseInt.length >= 1">
    <div class="box">
        <span class="title">Self Rating
        </span>
        <ng-container *ngFor="let question of feedbackResponseInt; index as i">
            <div class="inputs" fxLayout="row">
                <div class="leftBox">
                    <div class="questions">
                        <span>{{question?.parameter?.value}} : </span>
                        <div class="rating">
                            <span [class.active]="question.rating == 10"><img
                                    src="/assets/images/rating/very_dissatisfied.png" alt=""
                                    matTooltip="Very Dissatisfied"></span>
                            <span [class.active]="question.rating == 20"><img
                                    src="/assets/images/rating/dissatisfied.png" matTooltip="Dissatisfied"
                                    alt=""></span>
                            <span [class.active]="question.rating == 30"><img src="/assets/images/rating/ok.png"
                                    matTooltip="Ok" alt=""></span>
                            <span [class.active]="question.rating == 40"><img src="/assets/images/rating/satisfied.png"
                                    matTooltip="Satisfied" alt=""></span>
                            <span [class.active]="question.rating == 50"><img matTooltip="Very Satisfied"
                                    src="/assets/images/rating/very_satisfied.png" alt=""></span>
                        </div>
                    </div>
                </div>
                <div class="rightBox"><b>Remarks : </b>{{question.remarks}}</div>
            </div>
        </ng-container>
    </div>
</ng-container>
<ng-container *ngIf="feedbackResponseCustomer.length >= 1">
    <div class="box">
        <span class="title" *ngIf="isCustomer">Service Rating
        </span>
        <span class="title" *ngIf="!isCustomer">Customer's Rating
        </span>
        <ng-container *ngFor="let question of feedbackResponseCustomer; index as i">
            <div class="inputs" fxLayout="row">
                <div class="leftBox">
                    <div class="questions">
                        <span>{{question?.parameter?.value}} : </span>
                        <div class="rating">
                            <span [class.active]="question.rating == 10"><img
                                    src="/assets/images/rating/very_dissatisfied.png" alt=""
                                    matTooltip="Very Dissatisfied"></span>
                            <span [class.active]="question.rating == 20"><img
                                    src="/assets/images/rating/dissatisfied.png" matTooltip="Dissatisfied"
                                    alt=""></span>
                            <span [class.active]="question.rating == 30"><img src="/assets/images/rating/ok.png"
                                    matTooltip="Ok" alt=""></span>
                            <span [class.active]="question.rating == 40"><img src="/assets/images/rating/satisfied.png"
                                    matTooltip="Satisfied" alt=""></span>
                            <span [class.active]="question.rating == 50"><img matTooltip="Very Satisfied"
                                    src="/assets/images/rating/very_satisfied.png" alt=""></span>
                        </div>
                    </div>
                </div>
                <div class="rightBox"><b>Remarks : </b>{{question.remarks}}</div>
            </div>
        </ng-container>
    </div>
</ng-container>

<ng-container
    *ngIf="!(feedbackResponseCustomer?.length > 0 && isCustomer) && !(feedbackResponseInt?.length > 0 && !isCustomer)">
    <logzy-feedback (feedbackSubmited)="feedbackSubmit($event)"
        (feedbackCheck)="checkFeedback($event)"></logzy-feedback>
</ng-container>

<!-- <button>Change Rating</button>
<div class="contentBox" fxLayout="column">
    <span class="title"> Feedback</span>
    <span class="desc">Help us to enhance your experience in future. </span>
    <div class="feedbackForm">
        <div *ngFor=" let feedback of feedbackResponse; index  as i">
            <span>{{feedback?.parameter?.value}}</span>
            <div class="rating">
                <mat-radio-group [(ngModel)]="feedback.rating" name="rating">
                    <mat-radio-button [value]="10" (click)="set_rating(10, i)"><img
                            src="/assets/images/rating/very_dissatisfied.png" alt=""
                            matTooltip="Very Dissatisfied"></mat-radio-button>
                    <mat-radio-button [value]="20" (click)="set_rating(20, i)"><img
                            src="/assets/images/rating/dissatisfied.png" matTooltip="Dissatisfied"
                            alt=""></mat-radio-button>
                    <mat-radio-button [value]="30" (click)="set_rating(30, i)"><img src="/assets/images/rating/ok.png"
                            matTooltip="Ok" alt=""></mat-radio-button>
                    <mat-radio-button [value]="40" (click)="set_rating(40, i)"><img
                            src="/assets/images/rating/satisfied.png" matTooltip="Satisfied" alt=""></mat-radio-button>
                    <mat-radio-button [value]="50" (click)="set_rating(50, i)"><img matTooltip="Very Satisfied"
                            src="/assets/images/rating/very_satisfied.png" alt=""></mat-radio-button>
                </mat-radio-group>
            </div>
            <ng-container *ngIf="!(feedback.rating == 40 || feedback.rating == 50) ">
                <div class="comment" [class.active]="i==current_feedback_index || feedback.remarks!=''">
                    <app-text-field [isEditable]="true" [isMultiline]="true" [placeholder]="placeholder"
                        [(ngModel)]="feedback.remarks" fxFlex="100"></app-text-field>
                </div>
            </ng-container>
            <div class="btnb">
                <button mat-raised-button class="Save fbSubmit sleekBtn " (click)="updateFeedbackSubmit(feedback)">
                    Submit</button>
            </div>
        </div>
    </div>
</div> -->